import { I18nLocales, ILocales } from '@/interfaces/locales.interfaces';

export function getCountryCodeFromLocale(locale: I18nLocales | undefined): ILocales | undefined {
    if (locale === I18nLocales.nz) {
        return ILocales.en_NZ;
    } else if (locale === I18nLocales.au) {
        return ILocales.en_AU;
    } else {
        return undefined;
    }
}
